import React from 'react'
import PropTypes from 'prop-types'

import { useAuth } from './auth'
import { api } from '@shared/services/api'

const BalanceContext = React.createContext({})

function useBalance () {
  const context = React.useContext(BalanceContext)

  if (!context) {
    throw new Error('useContext must be used within an BalanceProvider')
  }

  return context
}

const BalanceProvider = ({ children }) => {
  const [totals, setTotals] = React.useState({})
  const [isVisible, setIsVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const { user: isSigned } = useAuth()

  const getBalance = React.useCallback(async () => {
    try {
      const { data } = await api.get(`${process.env.REACT_APP_URL_API}/wholesaler/customers/balance`)
      setTotals(data)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const toggle = React.useCallback(() => {
    setIsVisible((state) => !state)
  }, [])

  const refresh = React.useCallback(() => {
    if (!isLoading) {
      getBalance()
    }
  }, [getBalance, isLoading])

  React.useEffect(() => {
    if (isSigned) {
      getBalance()
    }
  }, [isSigned, getBalance])

  return (
    <BalanceContext.Provider
      value={{
        totals,
        isVisible,
        isLoading,
        toggle,
        refresh
      }}>
      {children}
    </BalanceContext.Provider>
  )
}

BalanceProvider.propTypes = {
  children: PropTypes.any
}

export { useBalance, BalanceProvider }
